/**
 * Thin fetch helpers that talk to your backend:
 *   GET  /api/users/me
 *   PUT  /api/users/me
 */

const API_BASE = process.env.REACT_APP_API_URL;

function requireApiBase() {
  if (!API_BASE) {
    throw new Error('Missing REACT_APP_API_URL');
  }
  return API_BASE;
}

function authHeaders(extra = {}) {
  const token = localStorage.getItem('accessToken');

  return {
    Accept: 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

export async function fetchCurrentUser() {
  const base = requireApiBase();

  const res = await fetch(`${base}/api/users/me`, {
    method: 'GET',
    credentials: 'include',
    headers: authHeaders(),
  });

  if (!res.ok) {
    let detail = '';
    try {
      detail = await res.text();
    } catch {}
    throw new Error(detail || `GET /api/users/me failed (${res.status})`);
  }

  return res.json();
}

export async function updateUserSettings(payload) {
  const base = requireApiBase();

  const res = await fetch(`${base}/api/users/me`, {
    method: 'PUT',
    credentials: 'include',
    headers: authHeaders({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let detail = '';
    try {
      detail = await res.text();
    } catch {}
    throw new Error(detail || `PUT /api/users/me failed (${res.status})`);
  }

  return res.json();
}